import { Panel } from 'components/ui';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { tryFetchReportByIdIfNeeded } from 'store/metaData/reports/actions';
import { EditableTitle, PanelActions, ReportInfo, Table } from '../components';

const defaultProps = {};
const propTypes = {
  slotId: PropTypes.number.isRequired,
  slots: PropTypes.array.isRequired,
  reports: PropTypes.array.isRequired,
};

class Slot extends PureComponent {
  componentDidMount() {
    const {
      slotId,
      tryFetchReportByIdIfNeeded,
      reports,
      slots
    } = this.props;
    const slot = slots.find(s => s.id === slotId);
    // this condition is used to define if adding new slot or not, cause we will fetch the report data from 'dashboard/${id}' when first time render the setting page.
    if (slot && _.isArray(reports) && !_.some(reports, { id: slot.reportId })) {
      tryFetchReportByIdIfNeeded(slot.reportId);
    }
  }

  render() {
    const { slotId } = this.props;

    return (
      <Panel
        panelClasses="report-theme-panel"
        actionsRight={<PanelActions id={slotId} />}
        panelTitle={<EditableTitle id={slotId} />}
      >
        <Table id={slotId} />
        <ReportInfo id={slotId} />
      </Panel>
    );
  }
}

const mapStateToProps = ({ global, metaData, dashboardSettings }) => ({
  lang: global.language,
  fields: metaData.fields.data,
  slots: dashboardSettings.details.slots,
  reports: metaData.reports.data,
});
const mapDispatchToProps = {
  tryFetchReportByIdIfNeeded
};
Slot.defaultProps = defaultProps;
Slot.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Slot);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/container/index.jsx